import * as appTypes from 'types/app';
import { DiscountType } from '@kouto/cart-prices';

export const DELETE_DISCOUNT_CODE = '@discount-code/delete-discount-code';

export const VALIDATE_DISCOUNT_CODE_REQUEST =
  '@discount-code/validate-discount-code-request';
export const VALIDATE_DISCOUNT_CODE_SUCCESS =
  '@discount-code/validate-discount-code-success';
export const VALIDATE_DISCOUNT_CODE_FAILURE =
  '@discount-code/validate-discount-code-failure';
export const VALIDATE_DISCOUNT_CODE_ONLY_ONE_COUPON_ALLOWED =
  '@discount-code/validate-discount-code-only-one-coupon-allowed';
export const RESET_DISCOUNT_CODE_STATUS =
  '@discount-code/reset-discount-code-status';
export const RESTORE_PERSISTED_DISCOUNT_CODE =
  '@discount-code/restore-persisted-discount-code';

export interface DiscountCode {
  discountCode: {
    code: string;
    discountType: DiscountType;
    type: string;
    value: number;
    experienceIds: string[];
    blackoutExperienceIds?: string[];
  };
  responseStatus: number;
  error: string;
  validationMessages: string;
  validateDiscountCodeStatus: (typeof appTypes)[keyof typeof appTypes];
}
